// src/components/room/RoomHeader.jsx
import React, { useState } from 'react';

export default function RoomHeader({ uiRoomId, isConnected, showChat, showUserList, showVoicePanel, onToggleChat, onToggleUsers, onToggleVoice, onLeaveRoom, unreadCount, usersCount }) {
  const [copied, setCopied] = useState(false);

  return (
    <div className="room-header">
      <div className="room-info">
        <span className="room-label">Room:</span>
        <span className="room-code" onClick={() => { navigator.clipboard.writeText(uiRoomId); setCopied(true); setTimeout(()=>setCopied(false),1500); }} title="Click to copy" style={{cursor:'pointer',position:'relative'}}>
          {uiRoomId}
          {copied && <span style={{position:'absolute',top:'-28px',left:'50%',transform:'translateX(-50%)',background:'#4ade80',color:'#000',fontSize:'0.7rem',fontWeight:600,padding:'3px 8px',borderRadius:'6px',whiteSpace:'nowrap',animation:'fadeInOut 1.5s ease'}}>Copied! ✓</span>}
        </span>
        <div className={`status-badge ${isConnected?'active':'inactive'}`}>
          <span className="status-dot"></span>
          <span className="status-text">{isConnected?'Connected':'Connecting'}</span>
        </div>
      </div>
      <div className="room-actions">
        <button 
          className={`btn btn-chat-toggle ${showVoicePanel ? 'active' : ''}`}
          onClick={onToggleVoice}
          title={showVoicePanel ? 'Hide Voice' : 'Show Voice'}
        >
          <span className="btn-icon">🎤</span>
          {showVoicePanel ? 'Voice' : 'Voice'}
        </button>
        <button className={`btn btn-chat-toggle ${showChat?'active':''}`} onClick={onToggleChat}>
          <span className="btn-icon">💬</span> {showChat?'Chat':'Chat'}
          {unreadCount>0 && !showChat && <span className="chat-badge">{unreadCount}</span>}
        </button>
        <button className={`btn btn-chat-toggle ${showUserList?'active':''}`} onClick={onToggleUsers}>
          <span className="btn-icon">👥</span> {showUserList?'Users':'Users'}
          {usersCount>0 && <span className="user-count-badge">{usersCount}</span>}
        </button>
        <button className="btn btn-danger" onClick={onLeaveRoom}><span className="btn-icon"></span>Leave Room</button>
      </div>
    </div>
  );
}